import React, { useEffect, useState } from "react";
import s from "./MembersPage.module.css";
import commonStyles from '../../common/CommonStyles.module.css';

const MembersPage = () => {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    const response = await fetch("/api/users/members");
    const data = await response.json();
    setMembers(data);
  };

  return (
    <div className={commonStyles.pageContainer}>
      <div className={commonStyles.contentContainer}>
        <div className={commonStyles.content}>
          <h2 style={{ color: 'rgb(151, 1, 14)', textAlign: 'center', fontFamily: 'Ysabeau SC, sans-serif' }}>
            Члены организации
          </h2>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {members.map((member) => (
              <li key={member.id} style={{ display: 'flex', alignItems: 'center', padding: '0.75rem', margin: '0.5rem 0', background: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: 6, transition: 'background 0.2s' }}>
                <span>{member.firstName} {member.lastName}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MembersPage;